import { useCallback } from 'react';
import { ApolloError } from '@apollo/client/errors';
import {
  CollectorScope,
  useInstallCollectorMutation,
  useInstallUserCollectorMutation
} from 'graphql/types';
export const useInstallCollector = (): {
  installCollector: (
    collectorId: string,
    scope: CollectorScope
  ) => Promise<any>;
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const [
    installCollectorMutation,
    { loading, error }
  ] = useInstallCollectorMutation();

  const [
    installUserCollectorMutation,
    { loading: userLoading, error: userError }
  ] = useInstallUserCollectorMutation();

  const installCollector = useCallback(
    async (collectorId: string, scope: CollectorScope) => {
      const input = {
        variables: {
          collectorId
        }
      };
      const mutationMethod =
        scope === CollectorScope.User
          ? installUserCollectorMutation
          : installCollectorMutation;
      return await mutationMethod(input);
    },
    [installCollectorMutation, installUserCollectorMutation]
  );

  return {
    installCollector,
    loading: loading || userLoading,
    error: error || userError
  };
};
